module.exports = __webpack_public_path__ + "static/media/banner-bg.af22a7e9.png";